import { render } from "./CertificateCatalog.vue?vue&type=template&id=126fa9ac&scoped=true"
import script from "./CertificateCatalog.vue?vue&type=script&lang=js"
export * from "./CertificateCatalog.vue?vue&type=script&lang=js"

import "./CertificateCatalog.vue?vue&type=style&index=0&id=126fa9ac&lang=css"
import "./CertificateCatalog.vue?vue&type=style&index=1&id=126fa9ac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126fa9ac"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
